module.exports = __webpack_public_path__ + "static/media/ukesunkissed.4b8d4287.png";